<div [formGroup]="form">
    <select cSelect formControlName="facility">
        <!-- <option [value]="null"></option> -->
        <option *ngFor="let facility of plants$ | async" [ngValue]="facility.facilityId" [hidden]="facility.facilityId == 10 && !showOptionAll">{{facility.facilityId}} - {{facility.facilityDescription}}</option>
    </select>
</div>